import type { IconSvgObject } from './types';

const Medal01Icon: IconSvgObject = [
  ["path", { d: "M21 8V3H3V8L12 12L21 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.0001 14L12.0001 12L8 14V19L12.0001 21L16.0001 19V14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 3V10.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.5 3V10.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Medal01Icon;
